const StatusRenderer = (props) => {
  const statusValue = props.value?.data?.[0];
  const isActive = statusValue === 1;

  return (
    <span
      className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${
        isActive ? "bg-green-100 text-green-800" : "bg-yellow-100 text-yellow-800"
      }`}
    >
      {isActive ? "Active" : "Inactive"}
    </span>
  );
};
    export default StatusRenderer;

